import { Box, Image, Text, Heading, Flex } from '@chakra-ui/react'

interface WhatsAppMessagePreviewRealProps {
  photoUrl?: string | null
  message: string
}

export function WhatsAppMessagePreviewReal({ photoUrl, message }: Readonly<WhatsAppMessagePreviewRealProps>) {
  return (
    <Box>
      <Heading size="md" mb={3}>Preview da mensagem:</Heading>

      <Flex
        bgImage="/whatsapp_bg.jpg"
        bgSize="cover"
        borderRadius="md"
        overflow="hidden"
        maxW="350px"
        position="relative"
        alignItems="end"
        justifyContent="end"
        h="auto"
        p={3}
      >
        <Box
          bg="#dcf8c6"
          borderRadius="20px"
          borderTopRightRadius="5px"
          px={3}
          py={2}
          maxW="80%"
          boxShadow="md"
          mb={1}
        >
          {photoUrl && (
            <Image
              src={photoUrl}
              alt="Preview da imagem"
              borderRadius="lg"
              maxH="200px"
              objectFit="cover"
              mb={2}
            />
          )}
          <Text fontSize="sm" whiteSpace="pre-wrap">{message}</Text>
          <Text fontSize="xs" color="gray.500" textAlign="right" mt={1}>09:45 </Text>
        </Box>
      </Flex>
    </Box>
  )
}
